import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IReamazeCredentials {
    username: string,
    api_key: string,
    brand: string,
    channelName: string
}

class ReamazeCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IReamazeCredentials = {} as IReamazeCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get username() { return this._changes.username; }
    public get api_key() { return this._changes.api_key; }
    public get brand() { return this._changes.brand; }
    public get channelName() { return this._changes.channelName; }


    public set username(v: string) { this._changes.username = v; }
    public set api_key(v: string) { this._changes.api_key = v; }
    public set brand(v: string) { this._changes.brand = v; }
    public set channelName(v: string) { this._changes.channelName = v; }


    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IReamazeCredentials;
    }

    public getUpdatedModel(): IReamazeCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default ReamazeCredentialsStore;
